
export default {
    get,
}

function get(value) {
    switch(value) {
        case 'accounts': return 'Cuentas'
        case 'admin': return 'Administrador'
        case 'arrival': return 'CEDIS'
        case 'biweekly': return 'Quincenal'
        case 'cedis': return 'Cedis'
        case 'charge': return 'Cargo'
        case 'charges': return 'Cargos'
        case 'created': return 'Creado'
        case 'credit': return 'Credito'
        case 'credits': return 'Creditos'
        case 'daily': return 'Diario'
        case 'delivered': return 'Entregado'
        case 'disabled': return 'Deshabilitado'
        case 'driver': return 'Conductor'
        case 'enabled': return 'Habilitado'
        case 'famale': return 'Mujer'
        case 'fixedprices': return 'Precios fijos'
        case 'invoices': return 'Facturas'
        case 'local': return 'Local'
        case 'location': return 'Dirección'
        case 'locations': return 'Direcciones'
        case 'male': return 'Hombre'
        case 'merchandises': return 'Mercancias'
        case 'monthDays': return 'Días del mes'
        case 'monthly': return 'Mensual'
        case 'national': return 'Nacional'
        case 'package': return 'Paquete'
        case 'packages': return 'Paquetes'
        case 'paid': return 'Pagado'
        case 'pending': return 'Pendiente'
        case 'pickups': return 'Recolecciones'
        case 'prepaid': return 'Prepago'
        case 'prepaids': return 'Guías prepago'
        case 'progress': return 'Progreso'
        case 'refund': return 'Reembolso'
        case 'refunds': return 'Reembolsos'
        case 'resolved': return 'Resuelto'
        case 'review': return 'Revisión'
        case 'shipment': return 'Envío'
        case 'shipments': return 'Envíos'
        case 'success': return 'Completado'
        case 'tracing': return 'Seguimiento'
        case 'user': return 'Usuario'
        case 'wallet': return 'Cartera'
        case 'weekly': return 'Semanal'
        default: return value
    }
}